var InFlight = InFlight || {};
InFlight.GTM = (function() {
  var GTM_EVENT = 'GTMEvent';
  var BUTTON_CLICKS = 'button-clicks';
  var LINK_CLICK = 'click-link';
  var OPPORTUNITY_DETAILS = 'opportunity-details';

  var _setUserId = function(data) {
    var currentUser = InFlight.User.currentUser();
    if (currentUser) {
      data.userId = InFlight.Utils.hash(currentUser);
    }
  };

  var _push = function(data) {
    window.dataLayer = window.dataLayer || [];
    dataLayer.push(data);
    console.log('GTM', data);
  };

  var _bidderRegistrationComplete = function(userId) {
    var data = {
      event: GTM_EVENT,
      eventCategory: 'registration',
      eventAction: 'completion',
      eventLabel: ''
    };

    if (userId) {
      data.userId = InFlight.Utils.hash(userId);
    }

    _push(data);
  };

  var _login = function() {
    var data = {
      event: GTM_EVENT,
      eventCategory: 'login',
      eventAction: 'completion',
      eventLabel: ''
    };

    _setUserId(data);
    _push(data);
  };

  var _buttonClick = function(action, category) {
    _push({
      event: GTM_EVENT,
      eventCategory: category,
      eventAction: BUTTON_CLICKS,
      eventLabel: action
    });
  };

  var _linkClick = function(action, category, includeUser) {
    var data = {
      event: GTM_EVENT,
      eventCategory: category,
      eventAction: LINK_CLICK,
      eventLabel: action
    };

    if (includeUser) {
      _setUserId(data);
    }
    _push(data);
  };

  var _placeBid = function() {
    _buttonClick('Place Bid', OPPORTUNITY_DETAILS);
  };

  var _acceptInvite = function() {
    _buttonClick('Accept Invitation', OPPORTUNITY_DETAILS);
  };

  var _viewPartnerRequests = function() {
    _buttonClick('View Partner Requests', OPPORTUNITY_DETAILS);
  };

  var _findPartner = function() {
    _buttonClick('Find Partner', OPPORTUNITY_DETAILS);
  };

  var _copyEvent = function() {
    _buttonClick('Copy Event URL', OPPORTUNITY_DETAILS);
  };

  var _emailEvent = function() {
    _buttonClick('Email Event', OPPORTUNITY_DETAILS);
  };

  var _searchEvents = function() {
    _buttonClick('Basic Search', OPPORTUNITY_DETAILS);
  };

  var _searchAll = function() {
    _buttonClick('Search All', 'homepage');
  };

  var _advancedSearch = function() {
    _buttonClick('Advanced Search', OPPORTUNITY_DETAILS);
  };

  var _newUser = function() {
    _push({
      event: GTM_EVENT,
      eventCategory: BUTTON_CLICKS,
      eventAction: 'Next',
      eventLabel: 'Start a new registration form'
    });
  };

  var _returningUser = function() {
    _push({
      event: GTM_EVENT,
      eventCategory: BUTTON_CLICKS,
      eventAction: 'Next',
      eventLabel: 'Continue from where you left’'
    });
  };

  var _getVirtualPageView = function() {
    return {
      event: 'virtualPageview',
      virtualPageURL: location.pathname
    };
  };

  var _biddreRegistrationStep = function(step, title) {
    var data = _getVirtualPageView();
    data.virtualPageTitle = 'Bidder Registratiion - ' + title;
    data.bidderRegistrationStep = 'Step ' + step + ' - ' + title;
    _push(data);
  };

  var _lookupBusStruct = function() {
    var data = _getVirtualPageView();
    data.virtualPageTitle = 'Bidder Registratiion - Find a Business Structure';
    data.bidderRegistrationStep = '';
    _push(data);
  };

  var _pageView = function() {
    var title = getPageTitle();
    var data = _getVirtualPageView();
    data.virtualPageTitle = title;
    _push(data);
  };

  var _homePageAppClick = function(appName) {
    _linkClick(appName, 'SupplierDashboard', true);
  };

  var _workCenter = function() {
    var data = {
      event: 'virtualPageview',
      virtualPageURL: '/workcenter',
      virtualPageTitle: 'Work Center'
    };
    _setUserId(data);
    _push(data);
    _triggerHJ('view_workcenter');
  };

  var listenForPageViews = function() {
    var lastPage;
    $(document).on('NLX:pageComplete', function() {
      var currentPage = location.pathname;
      if (currentPage !== lastPage) {
        _pageView();
      }
      lastPage = currentPage;
    });
  };
  listenForPageViews();


  var _triggerHJ = function(triggerName){
    if(!window['hj']){
      setTimeout(function(){
        _triggerHJ(triggerName);
      },100)
    }else{
      hj('trigger', triggerName);
    }

  }

  return {
    pageView: _pageView,
    login: _login,
    home: {
      searchAll: _searchAll,
      appClick: _homePageAppClick,
      workCenter: _workCenter
    },
    events: {
      placeBid: _placeBid,
      acceptInvite: _acceptInvite,
      viewPartnerRequests: _viewPartnerRequests,
      findPartner: _findPartner,
      copy: _copyEvent,
      email: _emailEvent,
      search: _searchEvents,
      advancedSearch: _advancedSearch
    },
    bidderRegistration: {
      complete: _bidderRegistrationComplete,
      step: _biddreRegistrationStep,
      newUser: _newUser,
      returningUser: _returningUser,
      lookupBusStruct: _lookupBusStruct
    }
  };
})();
